/**
 * Builds a URL query string from an object of parameters.
 * Example:
 *   buildQueryString({ location: 'Batavia', startDate: '2025-10-13' })
 *   → "location=Batavia&startDate=2025-10-13"
 */
export const buildQueryString = (params = {}) => {
  const queryParts = [];

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") {
      queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }

  return queryParts.join("&");
};

/**
 * Returns current week start and end dates (Monday–Sunday)
 * in both Date and formatted ("YYYY-MM-DD") formats.
 */
export const getCurrentWeekDates = () => {
  const today = new Date();

  // Compute Monday (start of week)
  const day = today.getDay(); // Sunday=0, Monday=1, ... Saturday=6
  const diffToMonday = day === 0 ? -6 : 1 - day;

  // Clone to avoid mutation issues
  const start = new Date(today);
  start.setDate(today.getDate() + diffToMonday);

  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  // Format to YYYY-MM-DD
  const format = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    sDate: format(start),
    eDate: format(end),
    formattedStart: format(start),
    formattedEnd: format(end),
  };
};
